import _jsx from "@babel/runtime/helpers/jsx";

var _Icon, _FormattedMessage;

import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useSelectorProps } from 'hooks';
import Icon from 'components/Icon';
import { ResetFiltersButtonWrapper } from './styles';

function ResetFiltersButton() {
  var history = useHistory();
  var selectorProps = useSelectorProps();
  var handleClick = useCallback(function () {
    history.push({
      pathname: selectorProps.location.pathname,
      search: ''
    });
  }, [selectorProps]);
  return /*#__PURE__*/_jsx(ResetFiltersButtonWrapper, {
    onClick: handleClick
  }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
    name: "resetFilters"
  })), _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    id: "MoreFilters.resetFiltersButton"
  })));
}

export default ResetFiltersButton;